import axiosInstance from '../utils/AxiosConfig';
import dayjs from 'dayjs';

import { DEFAULT_CURRENCY, getActiveCurrency } from '../utils/currency';
export const getBranchDashboardData = async ({ month, year }) => {
  const start = dayjs(`${year}-${month}-01`);
  const end = start.endOf('month');

  const params = {
    from: start.format('YYYY-MM-DD'),
    to: end.format('YYYY-MM-DD'),
  };

  if (getActiveCurrency() !== DEFAULT_CURRENCY) params.currency = getActiveCurrency();
  const response = await axiosInstance.get('/reports/branches', { params });
  return response.data;
};
